import request from '../utils/http'

export function city(query) {
    return request({
        url: '/api/v1/categoryTag/city',
        method: 'get',
        params: query
    })
}

export function countryList(query) {
    return request({
        url: '/api/v1/area/countryList',
        method: 'get',
        params: query
    })
}

export function customerApplySelectOption(query) {
    return request({
        url: '/api/v1/customerApplySelectOption',
        method: 'get',
        params: query
    })
}

export function tag(query) {
    return request({
        url: '/api/v1/categoryTag/index',
        method: 'get',
        params: query
    })
}


export function customerApplyResult(query) {
    return request({
        url: '/api/v1/customerApplyResult',
        method: 'get',
        params: query
    })
}

export function customerApply(query) {
    return request({
        url: '/api/v1/customerApply',
        method: 'post',
        data: query,
    })
}

// 获取验证码
export function sendMobile(query) {
    return request({
        url: '/api/v1/sendMobile',
        method: 'post',
        data: query,
    })
}

export function mobileCodeAuth(query) {
    return request({
        url: '/api/v1/mobileCodeAuth',
        method: 'post',
        data: query,
    })
}

export function reApplyList(query) {
    return request({
        url: '/api/v1/reApply/applyList',
        method: 'get',
        params: query
    })
}

export function downloadExample(query) {
    return request({
        url: '/api/v1/reApply/downloadExample',
        method: 'get',
        params: query
    })
}

export function customerReplaceApply(query) {
    return request({
        url: '/api/v1/reApply/customerReplaceApply',
        method: 'post',
        data: query,
    })
}

export function importApply(query) {
    return request({
        url: '/api/v1/reApply/importApply',
        method: 'post',
        data: query,
    })
}

export function getEnterTime(query) {
    return request({
        url: '/api/v1/getEnterTime',
        method: 'get',
        params: query,
    })
}

export function checkEnterTime(query) {
    return request({
        url: '/api/v1/checkEnterTime',
        method: 'post',
        data: query,
    })
}

export function userReservation(query) {
    return request({
        url: '/api/v1/userReservation',
        method: 'get',
        params: query,
    })
}

// 公司搜索
export function search(query) {
    return request({
        url: '/api/v1/company/search',
        method: 'post',
        data: query,
    })
}



// WEBPACK FOOTER //
// ./src/api/data.js